document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.collage-sliding-container');
  
  if (!sections.length) return;

  // Helper function to debounce resize events
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }

  sections.forEach(section => {
    const track = section.querySelector('.collage-sliding-track');
    const items = track ? track.querySelectorAll('.collage-sliding-track__item') : [];
    let progressSegments = section.querySelectorAll('.collage-progress-segment');
    const prevBtn = section.querySelector('.collage-caret-left.prev');
    const nextBtn = section.querySelector('.collage-caret-right.next');



    if (!track || !items.length || !prevBtn || !nextBtn) {
      console.error('Missing required elements in collage section:', section);
      return;
    }

    let index = 0;
    let itemsPerView = getItemsPerView();
    let totalPages = Math.max(1, Math.ceil(items.length / itemsPerView));

    // Initialize slider
    initSlider();

    function getItemsPerView() {
      return window.innerWidth <= 749 ? 2 : 4;
    }

    function initSlider() {
      itemsPerView = getItemsPerView();
      totalPages = Math.max(1, Math.ceil(items.length / itemsPerView));
      createProgressSegments();
      updateSlider();
    }

    function createProgressSegments() {
      const progressContainer = section.querySelector('.collage-progress-indicators');
      if (!progressContainer) return;
      
      // Clear existing segments
      progressContainer.innerHTML = '';
      
      // Create segments based on total pages
      for (let i = 0; i < totalPages; i++) {
        const segment = document.createElement('div');
        segment.className = 'collage-progress-segment';
        segment.setAttribute('data-index', i);
        progressContainer.appendChild(segment);
      }
      
      // Re-select the segments after creation
      progressSegments = section.querySelectorAll('.collage-progress-segment');
      
      // Add click handlers to new segments
      progressSegments.forEach((segment, segmentIndex) => {
        segment.addEventListener('click', () => {
          if (segmentIndex < totalPages) {
            index = segmentIndex;
            updateSlider();
          }
        });
      });
    }

    function updateSlider(animate = true) {
      // Calculate item width including gap
      const itemWidth = items[0].offsetWidth + parseInt(window.getComputedStyle(track).gap);
      
      // Update track position
      if (animate) {
        track.style.transition = 'transform 0.4s ease';
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = `translateX(-${index * itemWidth * itemsPerView}px)`;

      // Update progress segments
      if (progressSegments.length > 0) {
        progressSegments.forEach((segment, segmentIndex) => {
          segment.classList.remove('active');
          if (segmentIndex === index) {
            segment.classList.add('active');
          }
        });
      }

      // Update button states
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= totalPages - 1;
    }

    // Event listeners
    prevBtn.addEventListener('click', () => {
      if (index > 0) {
        index--;
        updateSlider();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (index < totalPages - 1) {
        index++;
        updateSlider();
      }
    });

    // Handle window resize with debounce
    const handleResize = debounce(() => {
      const newItemsPerView = getItemsPerView();
      if (newItemsPerView !== itemsPerView) {
        index = 0;
        initSlider();
        // Force a reflow to ensure the new layout is applied
        track.style.display = 'none';
        track.offsetHeight; // Force reflow
        track.style.display = '';
        updateSlider(false);
      }
    }, 250);

    window.addEventListener('resize', handleResize);
  });
});